import React, { useState } from "react";
// import "../../../../../pages/dashboard/Modelcss.css"
import styles from "./PublicResult.module.css";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";

export default function PublicResult({
  batch_id,
  event_id,
  userid,
  handleflagReload,
  method_of_test,
}) {
  const [showModal, setShowModal] = useState(true);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSubmit = () => {
    const createPublishResults = {
      batch_id: batch_id,
      event_id: event_id,
      published_by: userid,
    };
    AxiosInstance.post("api/test/publish/results", createPublishResults).then(
      (res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          handleflagReload();
        } else {
          toast.error(res.data.message);
          handleClose();
        }
      }
    );
  };

  return (
    <>
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className={styles.view_title} id="exampleModalLabel">
              Publish Results
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container ">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div>
                  <p className={`${styles.view_bold} ${styles.AddMargin}`}>
                    Are you sure you want to publish the result now?
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p className={styles.cancel_button} onClick={handleClose}>
            Back to View Test
          </p>
          <button
            type="button"
            className={styles.DashboardButton}
            onClick={handleSubmit}
          >
            <a href="javascript:void(0)">Publish Now</a>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
